import { candidateService } from '@/services/api/candidate.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { candidateModel } from '@/models/api/candidate.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const CANDIDATE_MODULE = "api/candidate";

// ACTIONS
export const GET_ALL_CANDIDATE = 'getAllCandidate';
export const CREATE_CANDIDATE = 'createCandidate';
export const GET_CANDIDATE = 'getCandidate';
export const UPDATE_CANDIDATE = 'updateCandidate';
export const UPDATE_CANDIDATE_STATUS = 'updateCandidateStatus';
export const UPDATE_CANDIDATE_APPLICATION = 'updateCandidateApplication';
export const SOFT_DELETE_CANDIDATE = 'softDeleteCandidate';
export const EXPORT_CANDIDATE_PDF = 'exportCandidatePdf';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_CANDIDATE_SUCCESS = "allCandidateSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_CANDIDATE_SUCCESS = "getCandidateSuccess";

export const actions = {
    [EXPORT_CANDIDATE_PDF]({commit}, {data}) {
        commit(REQUESTING, 'save');
        return candidateService
            .exportPdf(data)
            .then((result) => {
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_ALL_CANDIDATE]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return candidateService
            .getAll(filter)
            .then((result) => {
                commit(ALL_CANDIDATE_SUCCESS, {data: result});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_CANDIDATE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return candidateService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_CANDIDATE]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return candidateService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_CANDIDATE_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_CANDIDATE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return candidateService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_CANDIDATE_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return candidateService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_CANDIDATE_APPLICATION]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return candidateService
            .updateApplication(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [SOFT_DELETE_CANDIDATE]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return candidateService
            .softDelete(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('message.deleteXSuccess')});
                commit(SUCCESS);
                dispatch(GET_ALL_CANDIDATE, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_CANDIDATE_SUCCESS](state, {data}) {
        let candidate = data.data || [];
        state.list.data = candidate;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = candidate.map(item => candidateModel(item));
        }
    },
    [GET_CANDIDATE_SUCCESS](state, data) {
        state.details = candidateModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
